const FranchiserService = {
    getBillInvoiceData: function (billId, currency) {
        let url = `/franchiser/bills/${billId}/invoice-data`;
        if(typeof currency !== 'undefined') url += '/' + currency;

        return $.ajax({
            async: true,
            url: url,
            method: 'GET',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
}

export {FranchiserService};